import { toSignalTypeKey } from "app/pages/sales-intelligence/domain/signals/utils/signal-key";
import type SignalTypeListEntry from "app/pages/sales-intelligence/sub-modules/signals/models/view/SignalTypeListEntry";
import signalsService from "app/pages/sales-intelligence/sub-modules/signals/services/signalsService";
import signalsI18nKeys from "app/pages/sales-intelligence/sub-modules/signals/utils/i18n";

import SignalsFilterResult from "../../components/filters/SignalsFilter/SignalsFilterResult";
import SignalsFilterView from "../../components/filters/SignalsFilter/SignalsFilterView";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import type { LeadsSearchFilterInstance } from "../../types/leadsSearchFilterInstance";

import { resolveLockedGateStatus } from "./lockedGateViews";
import SignalsFilter from "./SignalsFilter";

export const createSignalsFilter = (entry: SignalTypeListEntry): LeadsSearchFilterInstance => ({
    key: toSignalTypeKey(entry.signalType),
    trackingName: `${entry.signalType} Signals`,
    apiCategory: "signalsFilters",
    category: leadsFilterCategoryMap.signals,
    title: { key: signalsI18nKeys.signalTypeFilterTitle(entry.signalType) },
    tooltipText:
        entry.lifecycleState === "coming-soon" || entry.lifecycleState === "locked"
            ? undefined
            : { key: signalsI18nKeys.emptyStateText(entry.signalType) },
    tag: entry.presentation.Badge,
    gateStatus: resolveLockedGateStatus(entry),
    filter: new SignalsFilter({
        options: {
            signalType: entry.signalType,
            availableUISignals: entry.signals,
            presentation: entry.presentation,
        },
        dependencies: { signalsService },
    }),
    filterView: SignalsFilterView,
    filterResultView: SignalsFilterResult,
});

export default createSignalsFilter;
